import {cn} from '@/lib/utils'

type StackedBarLegendTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral'

export interface StackedBarLegendItem {
    label: string
    value: number
    tone: StackedBarLegendTone
}

interface StackedBarLegendProps {
    items: ReadonlyArray<StackedBarLegendItem>
    className?: string
    'data-testid'?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const toneDotClass: Record<StackedBarLegendTone, string> = {
    success: 'bg-status-success',
    warning: 'bg-status-warning',
    danger: 'bg-status-danger',
    info: 'bg-status-info',
    neutral: 'bg-muted-foreground/30',
}
/* eslint-enable i18next/no-literal-string */

/**
 * Legend for a stacked bar chart — a small coloured dot + label: value per item.
 * Pair with {@link SegmentedProgress} for the bar itself.
 */
export function StackedBarLegend({items, className, 'data-testid': testId}: StackedBarLegendProps) {
    return (
        <ul
            className={cn('flex flex-wrap gap-x-4 gap-y-1 text-muted-foreground list-none m-0 p-0', className)}
            data-testid={testId}
        >
            {items.map((item) => (
                <li key={item.label} className="flex items-center gap-1.5">
                    <span className={cn('h-2.5 w-2.5 rounded-full', toneDotClass[item.tone])}/>
                    <span>{item.label}: {item.value}</span>
                </li>
            ))}
        </ul>
    )
}
